
import RefreshCircle from "../../../assets/duotone/RefreshCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RefreshCircleIcon({ className, dataTestid = "RefreshCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RefreshCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
